import { Tag, Tooltip } from 'antd'
import { menuBuilderMissingProductsCopy as copy } from 'src/constants/menuBuilderCopy'

const MissingProductsListBadge = () => (
  <Tooltip title={copy.listBadgeTooltip}>
    <Tag
      style={{
        backgroundColor: '#fff2e8',
        borderColor: '#ffb366',
        color: '#d46b08',
        fontSize: '10px',
        lineHeight: '18px',
        margin: 0,
        fontWeight: 600,
      }}
    >
      ⚠ {copy.listBadgeLabel}
    </Tag>
  </Tooltip>
)

export default MissingProductsListBadge
